import type { Action } from 'models/actionPlan';
import React, { useRef, useState } from 'react';
import { useRouter } from 'next/router';

interface FaqItemProps {
    action: Action;
}

const FaqItem: React.FC<FaqItemProps> = ({ action }) => {
    const [isOpen, setIsOpen] = useState(false); // FAQ açık mı kapalı mı kontrol etmek için state
    const contentRef = useRef<HTMLDivElement>(null); 
    const { locale } = useRouter();

    const toggleFaq = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className='faq-section'>
            <div className="faq-wrapper">
                <div data-delay="0" data-hover="false" className="faq-item w-dropdown">
                    <div className={`faq-item-toggle w-dropdown-toggle ${isOpen ? "w--open" : ""}`}
                        id="w-dropdown-toggle-7"
                        aria-controls="w-dropdown-list-7"
                        aria-haspopup="menu"
                        aria-expanded={isOpen ? 'true' : 'false'}
                        role="button"
                        onClick={toggleFaq}>
                        <div className="faq-title-wrapper">
                            <div className="action-heading-set">
                                <div className="action-number">
                                    <div className="tagline-heading">{action.action_no}</div>
                                </div>
                                <h4 className="paragraph-large">{action.action}</h4>
                            </div>
                            <div className="faq-icon-circle" >
                                <img
                                    loading="lazy"
                                    src="/images/66b22a034b5bccd573000269_PlusIcon.svg"
                                    alt="Expand"
                                    className="faq-icon"
                                    style={{
                                        transform: isOpen
                                            ? 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateZ(45deg)'
                                            : 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateZ(0deg)',
                                        transition: 'transform 400ms ease-in-out'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <nav className={`faq-content-wrap w-dropdown-list ${isOpen ? "w--open" : ""}`}
                        id="w-dropdown-list-7"
                        aria-labelledby="w-dropdown-toggle-7"
                        style={{
                            maxHeight: isOpen
                                ? `${contentRef.current?.scrollHeight}px` // İçeriğin doğal yüksekliğini kullan
                                : '0px',
                            overflow: 'hidden',
                            transition: 'max-height 400ms ease-in-out'
                        }}
                    >
                        <div className="faq-content"
                            ref={contentRef}
                            style={{
                                transform: isOpen
                                    ? 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1)'
                                    : 'translate3d(0px, -10px, 0px) scale3d(1, 1, 1)',
                                opacity: isOpen ? 1 : 0,
                                transition: 'transform 400ms ease-in-out, opacity 400ms ease-in-out',
                                transformStyle: 'preserve-3d'
                            }}
                        >
                            <div id="w-node-_4836656f-aea2-605b-8bd3-e6f3ef382335-e090c599" className="micro-heading">
                                
                                  {locale?.includes('tr') ? 'Açıklama' : 'Description' }
                            </div>
                            <p className="paragraph-regular" dangerouslySetInnerHTML={{ __html: action.description?.replace(/\n/g, '<br>') || '' }} />
                            <div className="related-partners-grid">
                                <div id="w-node-_2ddb183c-ee8b-675a-d957-8775b15ea575-e090c599" className="micro-heading">
                                   {locale?.includes('tr') ? 'Sorumlu Kurum' : 'Responsible Institution' }
                                </div>
                                <p id="w-node-_2ddb183c-ee8b-675a-d957-8775b15ea579-e090c599" className="paragraph-small">
                                    {action.responsible_institution}
                                </p>
                                {action.related_institutions && (
                                    <>
                                        <div id="w-node-_2ddb183c-ee8b-675a-d957-8775b15ea577-e090c599" className="micro-heading">
                                            {locale?.includes('tr') ? 'İlgili Kuruluş' : 'Related Institution' }
                                        </div>
                                        <p id="w-node-_2ddb183c-ee8b-675a-d957-8775b15ea57b-e090c599" className="paragraph-small">
                                            {action.related_institutions}
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default FaqItem;
